
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PopupService } from '../../../core/services/popup.service';
import { LmsEventDetails } from '../../model/lms-event-details.model';
import { MenuItem } from '../../model/menu-item.model';
import { Tab } from '../../model/tab.model';
import { AppUtilityService } from '../../services/app-utility.service';
import { ConfigService } from '../../services/config.service';
import { EditModeService } from '../../services/edit-mode.service';
import { LmsMenuService } from '../../services/lms-menu.service';
import { LmsModuleService } from '../../services/lms-module.service';
import { LmsRendererService } from '../../services/lms-renderer.service';
import { TabService } from '../../services/tab.service';
import { UtilService } from '../../services/util.service';
import { CanDeactivateViaEditGuardService } from './../../../core/services/can-deactivate-via-edit-guard.service';
import { RoutePopup } from './../../model/route-popup.model';
import { PageResetService } from './../../services/page-reset.service';
import { RouteChangePopupService } from './../../services/route-change-popup.service';
import { LmsBaseAppComponent } from './../base-app/lms-base-app.component';


/**
 * @export
 * @class LmsPageComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-page',
  templateUrl: './lms-page.component.html',
  styleUrls: ['./lms-page.component.scss']
})
export class LmsPageComponent extends LmsBaseAppComponent implements OnInit, AfterViewInit, OnDestroy {

  tabs: Tab[];

  filteredTabs: Tab[];

  selectedMenu: MenuItem;

  selectedTab: Tab;
  protected service: any;
  routePopupData: RoutePopup;
  tabSubscription; any;
  selectedTabSubscription: any;
  newTabSubscription: any;
  routerSubscription: any;
  removeTabSubscription: any;
  currentUrl: string;
  currentScreen: string;
  nextScreen: string;
  tabLevelDialog: number;
  //showHeader: boolean;

  /**
   * Creates an instance of LmsPageComponent.
   * @param {TabService} tabService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {ConfigService} configService
   * @param {UtilService} utilService
   * @param {Router} router
   * @param {ActivatedRoute} route
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {CanDeactivateViaEditGuardService} canDeactivateViaEditGuardService
   * @param {PopupService} popupService
   * @param {PageResetService} pageResetService
   *
   * @memberOf LmsPageComponent
   */
  constructor(private tabService: TabService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    configService: ConfigService,
    utilService: UtilService,
    private router: Router,
    private route: ActivatedRoute,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    private canDeactivateViaEditGuardService: CanDeactivateViaEditGuardService,
    popupService: PopupService,
    private lmsRenderer: LmsRendererService,
    private appUtilityService: AppUtilityService,
    pageResetService: PageResetService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.tabLevelDialog = this.configService.getConfigData().tabIndex.dialogBox;
    this.service = pageResetService;
    this.routePopupData = { status: false, message: '' };
    this.routeChangePopupService.routeChange.subscribe(data => {
      if (this.selectedTab) {
        this.routePopupData = <RoutePopup>data;
        if (this.selectedTab.type === 'Terminal' || this.selectedTab.type === 'Train' || this.selectedTab.type === 'Locomotive') {
          this.currentScreen = this.selectedTab.type + ' ' + this.selectedTab.subType;
        } else {
          this.currentScreen = this.selectedTab.type;
        }
        let routeParam = [];
        if (this.routePopupData.nextUrl) {
          routeParam = this.routePopupData.nextUrl.split('/');
          const type = this.camelize(<string>routeParam[1]);
          const subType = this.camelize(<string>routeParam[2]);
          if (type === 'Terminal' || type === 'Train' || type === 'Locomotive') {
            this.nextScreen = type + ' ' + subType;
          } else {
            this.nextScreen = type;
          }
        } else {
          this.nextScreen = 'Next Screen';
        }
      }
    });
  }

  // Add this getter
  get showHeader(): boolean {
    return this.getParameterByName('showHeader') !== 'false';
  }

  setFocus(id) {
    this.appUtilityService.setFocusToFirstElement(id);
  }

  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toUpperCase() : letter.toLowerCase();
    }).replace(/\s+/g, '');
  }



  /**
   * This is used to intialization of our application which handles al tabs
   * @memberOf LmsPageComponent
   */
  ngOnInit() {
    this.tabSubscription = this.tabService.tabStoreObservable.subscribe(data => {
      this.tabs = data;
      if (this.tabs) {
        this.selectedTab = this.tabs.find((tab) => { return tab.selected; });
        if (this.selectedTab) {
          this.selectedMenu = <MenuItem>(this.lmsMenuService.getMenuItem(this.selectedTab.type));
          this.filteredTabs = this.tabs.filter((tab) => { return this.selectedTab.type === tab.type; });
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
        }
      }
    });

    this.selectedTabSubscription = this.lmsModuleService.selectedTab.subscribe((data) => {
      if (!this.utilService.isEmptyObject(data)) {
        this.selectedTab = data;
        this.tabService.notifyChange(<LmsEventDetails>({
          type: this.configService.getConfigData().tab.event.update,
          data: this.selectedTab
        }));
      }
    });

    this.removeTabSubscription = this.lmsModuleService.deleteTab.subscribe((data) => {
      if (!this.utilService.isEmptyObject(data)) {
        this.tabService.notifyChange(<LmsEventDetails>({
          type: this.configService.getConfigData().tab.event.remove,
          data: data
        }));
      }
    });

    // every time when url change we are updating url
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        let currentRoute = this.route.root;
        this.currentUrl = '';
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
          this.currentUrl += '/';
          if (currentRoute.snapshot && currentRoute.snapshot.url && currentRoute.snapshot.url.length) {
            this.currentUrl += currentRoute.snapshot.url[0].path;
          } else {
            this.currentUrl += this.configService.getConfigData().menu.defaultType;
          }
        }
      });
  }

  ngAfterViewInit() {
    this.lmsRenderer.calculateHeightWidth();
  }

  /**
   * @param {LmsEventDetails} lmsEventDetails
   * @memberOf LmsPageComponent
   */
  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    this.tabService.notifyChange(lmsEventDetails);
  }

  @HostListener('window:resize') calculateHeightWidth() {
    this.lmsRenderer.calculateHeightWidth();
  }

  /**
   * This is used to unsubscribe from observable service.
   * @memberOf LmsPageComponent
   */
  ngOnDestroy() {
    this.removeTabSubscription.unsubscribe();
    this.selectedTabSubscription.unsubscribe();
    this.tabSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
    super.destroy();
  }

  getParameterByName(name: string, url?: string) {
        if (!url) {
            url = window.location.href;
        }
      name = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) { return null; };
        if (!results[2]) { return ''; };
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
